module.exports = __webpack_public_path__ + "static/img/--info.de0d5ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/--info.jpg
// module id = cIbx
// module chunks = 101